import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from "./add-new-user.service"

export interface CabinetEvent {
  cuid: string;
  cabinet_users_id: string;
  event_type: string;
  product_description: string;
  event_timeStamp: string;
  created_at: string;
  updated_at: string;
  cabinet_users: User;
}

export interface CabinetEventResponse {
  cabinetEvents: CabinetEvent[];}

@Injectable({
  providedIn: 'root'
})
export class CabinetEventService {

  constructor(private http: HttpClient) { }

  getEventSummary(): Observable<CabinetEventResponse> {
    console.log("hello")
    return this.http.get<CabinetEventResponse>(`${environment.apiUrl}/api/cabinet-events`);
  }

  getEvents(start?, end?, type?, page?, sortBy?, sortDir?): Observable<CabinetEventResponse> {

    let p = {};

    if (type) {
      p['type'] = type;
    }

    if (start) {
      p['start_date'] = start;
    }

    if (end) {
      p['end_date'] = end;
    }

    if (page) {
      p['page'] = page;
    }

    if (sortBy) {
      p['sort_by'] = sortBy;
    }

    if (sortDir) {
      p['sort_dir'] = sortDir;
    }
    console.log(page,sortBy,sortDir)
    console.log(p)

    return this.http.get<CabinetEventResponse>(`${environment.apiUrl}/api/cabinet-events`, {params: p});

  }
}
